import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IParameterUnit;

const parameterUnitSlice = createSlice({
    name: "unit",
    initialState,
    reducers: {
        setParameterUnit: (state, action: PayloadAction<IParameterUnit | undefined>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setParameterUnit } = parameterUnitSlice.actions;
export default parameterUnitSlice.reducer;

export const getParameterUnit = (state: RootState) => state.parameterUnit;
